module.exports = __webpack_public_path__ + "static/media/iuc.89a165ac.png";